import React from 'react';
import { Icon, Divider, Pagination, Button, PaginationProps } from 'semantic-ui-react';
import ArchivioMobile from './ArchivioMobile';
import { Archivio } from '../models';

type ArchivioMobileProps = {
    archivi: ReadonlyArray<Archivio>,
    page: number,
    itemsCount: number,
    pageSize: number,
    backOnTopText: string,
    onPageChanged: (page: number) => void
    onFileClick: (e: any, data: any) => void
}

export default class ArchiviMobile extends React.Component<ArchivioMobileProps> {

    render() {
        const { archivi } = this.props;
        return (
            <div>
                {archivi.map(this.renderArchivio)}
                {archivi.length > 0 && this.renderPagination()}
                <Divider hidden />
                {archivi.length > 0 && this.renderBackOnTop()}
                <Divider hidden />
            </div>
            
        );
    }
    
    renderArchivio = (archivio: Archivio) => {
        return <ArchivioMobile archivio={archivio} onFileClick={this.props.onFileClick} key={archivio.idArchivio} />;
    }

    renderPagination = () => {
        const { page, itemsCount, pageSize } = this.props;
        const pageCount = Math.ceil(itemsCount / pageSize);
        return (
            <Pagination 
                activePage={page} 
                totalPages={pageCount} 
                onPageChange={this.onPageChange} 
                firstItem={null}
                lastItem={null} 
            />
        );
    }

    renderBackOnTop = () => {
        return (
            <Button basic labelPosition='left' onClick={() => window.scrollTo(0, 0)} style={{ width: 190 }}>
                <Icon name='arrow up' />
                {this.props.backOnTopText}
            </Button>
        );
    }

    onPageChange = (_: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: PaginationProps) => {
        const { activePage } = data;
        if (this.props.onPageChanged) {
            this.props.onPageChanged(Number(activePage));
        }
    }
}